import { Modal } from "@components/modal";
import styles from "./confirm.module.scss";
import Warning from "@assets/icons/warning-filled.svg";
import { Button } from "@components/button";

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
  title?: string;
  description?: string;
  deleteLabel: string;
  cancelLabel: string;
};

export const Confirm = ({
  onConfirm,
  onCancel,
  isOpen,
  title,
  description,
  deleteLabel,
  cancelLabel,
}: Props) => {
  return (
    <Modal title={""} isOpen={isOpen} onClose={() => {}}>
      <div className={styles.removeRequisiteConfirmContainer}>
        <Warning />
        <p className={styles.title}>{title ?? "Вы уверены?"}</p>
        <p className={styles.subTitle}>{description}</p>
      </div>
      <div className={styles.buttons}>
        <Button type="danger" onClick={onConfirm} buttonType="button">
          {deleteLabel}
        </Button>
        <Button type="outline" onClick={onCancel} buttonType="button">
          {cancelLabel}
        </Button>
      </div>
    </Modal>
  );
};
